export const serviceResponse = (data) => ({ data });

export default serviceResponse;
